import { render } from "./MbWrapView.vue?vue&type=template&id=0866b45e&scoped=true"
import script from "./MbWrapView.vue?vue&type=script&lang=js"
export * from "./MbWrapView.vue?vue&type=script&lang=js"

import "./MbWrapView.vue?vue&type=style&index=0&id=0866b45e&scoped=true&lang=css"

import exportComponent from "D:\\Students\\서용석\\vuestudy\\vuegeoje\\vuegeoje\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0866b45e"]])

export default __exports__